import React from 'react';

/**
 * TabNavigation - Horizontal tab navigation component with button-style design
 * Following SOLID principles with Single Responsibility
 *
 * @param {Array} tabs - Array of tab objects {id, label, icon}
 * @param {string} activeTab - Currently active tab ID
 * @param {Function} onTabChange - Callback when tab is clicked
 */
const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-[#050311]/95 backdrop-blur py-3 px-4">
      <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                relative flex items-center justify-center
                px-4 py-2.5 rounded-lg
                text-[11px] font-bold uppercase tracking-wider
                whitespace-nowrap transition-all duration-200
                border
                ${
                  isActive
                    ? 'bg-emerald-500/20 border-emerald-500/50 text-emerald-400 shadow-lg shadow-emerald-500/20'
                    : 'bg-white/[0.03] border-white/10 text-white/60 hover:bg-white/[0.06] hover:border-white/20 hover:text-white/80'
                }
              `}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigation;
